import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import CampaignIcon from '@material-ui/icons/Announcement';

export default class AnnouncementSidebar extends React.Component {
  render() {
    const { announcements } = this.props;

    return (
      <Paper>
        <div style={{padding: '10px 15px', display: 'flex', alignItems: 'center', backgroundColor: '#00000014'}}>
          <div style={{marginRight: '8px', display: 'flex'}}>
            <CampaignIcon color="primary" />
          </div>
          <Typography variant="h6">Announcements</Typography>
        </div>
        <Divider />

        <div style={{padding: '15px'}}>

          <List disablePadding>
            {announcements.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem disableGutters style={{flexDirection: 'column', paddingBottom: '15px'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '16px', alignItems: 'center'}}>
                    <Chip label={item.tag} component="div" variant={item.priority ? "default" : "outlined"} />
                    <Typography variant="caption" color="textSecondary">
                      {item.date}
                    </Typography>
                  </div>

                  <ListItemText
                    primary={
                      <Typography variant="subtitle2" style={{fontWeight: 'bold'}} paragraph>
                        {item.title}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="body2" color="textSecondary">
                        {item.content}
                      </Typography>
                    }
                  />
                </ListItem>
                {index < announcements.length - 1 && <Divider component="li" />}
              </React.Fragment>
            ))}
          </List>
        </div>
      </Paper>
    );
  }
}
